function fetchAccessTokenAndRedirect(email) {
	email = encodeURIComponent(email);
	fetch(`/apps/wise-app/generate-storefront-token?email=${email}`)
			.then(resp => resp.json())
			.then(data => {
				const {accessToken} = data;
				const redirectTo = new URL(localStorage.getItem('redirect_uri'));

				localStorage.removeItem('action');
				localStorage.removeItem('redirect_uri');

				redirectTo.searchParams.append('access_token', accessToken);
				window.location.replace(redirectTo)
			})
			.catch(e => console.error);
}